import { ILatestAction, INominationType } from './index.js'

export interface INomination {
  citation: string
  congress: number
  description: string
  latestAction: ILatestAction[]
  nominationType: INominationType
  number: number
  partNumber: string
  receivedDate: string
  updateDate: string
  url: string
}
